import type { NAccessRights } from '@app/types/AccessRights';
import type { NAuth } from '@app/types/Auth';

import type { WithActiveBranchId } from './global';

export namespace NOrganization {
  export type RegisterNewOrganizationPayload = {
    OwnerName: string;
    OwnerSurename: string;
    OwnerPhone: string;
    OwnerEmail: string;
    CompanyName: string;
    CityFiasId: string;
  };

  export type NewOrganizationDTO = {
    Id: 0;
    Timestamp: string;
    CompanyName: string;
    AddressLegal: string;
    AddressActual: string;
    OwnerName: string;
    OwnerEmail: string;
    OwnerPhone: string;
  };

  export type SearchOrganizationPayload = {
    tearm?: string;
    countryId?: number;
    city?: string;
    page?: number;
    pageSize: number;
  };

  export type SearchOrganizationResponse = {
    Data: [
      {
        Id: number;
        Database: string;
        Name: string;
        Inn: number | null;
        Kpp: number | null;
        City: string;
        Country: string;
        BranchName: string;
        BranchAddress: string;
        OwnerFullName: string;
        OwnerEmail: string;
        OwnerPhone: string;
      }
    ];
    Total: 0;
  };

  export type GetUsersParams = {
    page: number;
    pageSize: number;
    organizationId: number;
    Branches?: number[];
    Positions?: number[];
    Statuses?: string[];
    SearchTerm?: string;
    OrderProperty?: string;
    Descending?: boolean;
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  };

  export type GetUsersResponse = {
    Data: {
      FullName: string;
      Position: string;
      Phone: string;
      Email: string;
      BranchName: string;
      LastActivityDate: string;
      LastActivityOs: string;
      VersionFrontend: string;
      Avatar: string;
      IsDeleted: boolean;
    }[];
    Total: number;
  };

  export type OrganizationListItem = SearchOrganizationResponse['Data'][number];

  export type OrganizationInfo = {
    Id: string;
    Name: string;
  };

  export type GetWithModulesRightsDTO = OrganizationInfo & {
    Modules: NAccessRights.AccessRightsModuleDto[];
  };

  export type GetWithModulesRightsParams = {
    id?: number;
    ActiveBranchId?: number;
  };

  export type OrganizationUserIdDto = {
    OrganizationId: number;
    UserId: number;
  };

  export interface SearchOrganizationsAnalyticsRequest
    extends WithActiveBranchId {
    SearchName: string;
    DateFrom: string;
    DateTo: string;
    Page: number;
    PageSize: number;
  }

  export interface SearchOrganizationsAnalyticsResponse {
    SearchId: number;
    Organizations: ModelOrganizationAnalyticsRow[];
    TotalOrganizations: number;
    Page: number;
    PageSize: number;
  }

  export interface ModelOrganizationAnalyticsRow {
    Id: number;
    Name: string;
    RegistrationDate: string;
    NewClients: number;
    Revenue: number;
    UniqueUsers: number;
    LastLoginMax: string;
    Branches: ModelBranchAnalyticsRow[];
    UniqueUsersToday: number;
  }

  export interface ModelBranchAnalyticsRow {
    Id: number;
    Name: string;
    RegistrationDate: string;
    NewClients: number;
    Revenue: number;
    UsersCount: number;
    LastLoginMax: string;
  }

  export interface GetOrganizationsAnalyticsPageRequest
    extends WithActiveBranchId {
    searchId: number;
    page: number;
    pageSize: number;
  }

  export interface GetOrganizationsAnalyticsBySearchIdResponse {
    Organizations: OrganizationAnalyticsItem[];
    TotalOrganizations: number;
    Page: number;
    PageSize: number;
  }

  export interface OrganizationAnalyticsItem {
    Id: number;
    Name: string;
    RegistrationDate: string;
    NewClients: number;
    Revenue: number;
    UniqueUsers: number;
    LastLoginMax: string;
    Branches: OrganizationBranchAnalyticsItem[];
    UniqueUsersToday: number;
  }

  export interface OrganizationBranchAnalyticsItem {
    Id: number;
    Name: string;
    RegistrationDate: string;
    NewClients: number;
    Revenue: number;
    UsersCount: number;
    LastLoginMax: string;
  }
}
